import wisIncentives from './wis-incentives';
import wisVehicle from './wis-vehicle';
import account from './account';
import vcdaError from './vcdaError';

const root = {
	wisIncentives,
	wisVehicle,
	account,
	vcdaError
};

export default root;
